import React from 'react';
import { Home } from './pages/Home';
interface AppProps {
  /** Show the first-person "In my own words" essay between the portfolio and contact. */
  showApproach?: boolean;
}
export function App({
  showApproach = true
}: AppProps) {
  return <Home showApproach={showApproach} data-id="element-0" data-mp="3k92rqa47ciqj" />;
}